<template>
  <v-container
    grid-list-lg
    fluid
    class="pa-0"
  >
    <v-layout
      row
      wrap
    >
      <div class="px-4 d-flex align-center">
        <template v-if="device.deviceOS === 'ANDROID'">
          <img
            src="@/assets/android_tablet.png"
            alt="device"
            height="150"
          >
        </template>
        <template v-else-if="device.deviceOS === 'PRINTER'">
          <img
            src="@/assets/printer.png"
            alt="device"
            height="150"
          >
        </template>
        <template v-else>
          <img
            src="@/assets/ipad.png"
            alt="device"
            height="150"
          >
        </template>
      </div>
      <v-form
        id="devicesForm"
        ref="devicesForm"
      >
        <table class="pa-3 subheading">
          <tr>
            <td class="fixed-width">
              <span class="device-detials">
                Name
              </span>
            </td>
            <td>
              <span class="device-detials">
                :
              </span>
            </td>
            <td>
              <span>
                {{ device.name }}
              </span>
            </td>
          </tr>
          <tr v-if="device.ip">
            <td>
              <span class="device-detials">
                IP Address
              </span>
            </td>
            <td>
              <span class="device-detials">
                :
              </span>
            </td>
            <td>
              <span>
                {{ device.ip }}
              </span>
            </td>
          </tr>
          <tr>
            <td>
              <span class="device-detials">
                Device Type
              </span>
            </td>
            <td>
              <span class="device-detials">
                :
              </span>
            </td>
            <td>
              <span>{{ device.type }}</span>
            </td>
          </tr>
          <tr v-if="device.appVersion">
            <td>
              <span class="device-detials">
                App Version
              </span>
            </td>
            <td>
              <span class="device-detials">
                :
              </span>
            </td>
            <td v-if="device.appVersion === appVersion">
              <span>{{ device.appVersion }}</span>
            </td>
            <td v-else>
              <span>{{ device.appVersion }}</span>
              <!-- <span class="pa-2 yellow--text text--darken-3">Please update the app to {{ appVersion }}</span> -->
            </td>
          </tr>
          <tr v-if="device.interface">
            <td>
              <span class="device-detials">
                Interface Type
              </span>
            </td>
            <td>
              <span class="device-detials">
                :
              </span>
            </td>
            <td>
              <span>{{ device.interface }}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span class="device-detials">
                Location
              </span>
            </td>
            <td>
              <span class="device-detials">
                :
              </span>
            </td>
            <td>
              <span>{{ device.location }}</span>
            </td>
          </tr>
          <tr v-if="device.printers">
            <td>
              <span class="device-detials">
                Paired Printers
              </span>
            </td>
            <td>
              <span class="device-detials">
                :
              </span>
            </td>
            <td>
              <span>{{ getPrinterNames(device.printers) }}</span>
            </td>
          </tr>
          <tr v-if="device.deviceOS !== 'PRINTER' || device.status === 'error'">
            <td>
              <span class="device-detials">
                Status
              </span>
            </td>
            <td>
              <span class="device-detials">
                :
              </span>
            </td>
            <td>
              <span :class="device.status === 'online'? 'green--text' : 'red--text' ">
                {{ device.status }}
              </span>
            </td>
          </tr>
          <tr v-if="device.status === 'error'">
            <td>
              <span class="device-detials">
                Status Message
              </span>
            </td>
            <td>
              <span class="device-detials">
                :
              </span>
            </td>
            <td>
              <span class="red--text">
                {{ device.statusMessage }}
              </span>
            </td>
          </tr>
        </table>
      </v-form>
      <v-spacer />
      <v-btn
        color="primary"
        flat
        right
        large
        @click.stop="$emit('edit', device)"
      >
        Edit
      </v-btn>
      <v-btn
        color="error"
        flat
        right
        large
        @click.stop="$emit('unpair', device)"
      >
        {{ device.deviceOS === 'PRINTER'? 'delete': 'unpair' }}
      </v-btn>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  name: 'Device',
  props: {
    device: {
      type: Object,
      default: () => {},
      required: true
    },
    devices: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data() {
    return {
      appVersion: ''
    };
  },
  methods: {
    getPrinterNames(pids) {
      let printerNames = [];
      pids.forEach(pid => {
        if (!pid) return;
        printerNames.push(
          this.devices.filter(device => device.id === pid)[0].name
        );
      });
      // console.log(printerNames);
      return printerNames.toString();
    }
  }
};
</script>
<style scoped>
.device-detials {
  padding: 0px 12px;
  font-weight: bold;
}
.fixed-width {
  min-width: 140px;
}
</style>
